import React from "react";

import { FormattedMessage } from "react-intl";

import { APP_NAME, CLI_COMMAND_NAME } from "Constants/documentationUrls";

interface FormattedMessageWithConfigValuesProps {
  id: string;
  values?: Record<string, string>;
}

export const FormattedMessageWithConfigValues = ({
  id,
  values
}: FormattedMessageWithConfigValuesProps) => {
  return (
    <FormattedMessage
      id={id}
      values={{
        cli_name: CLI_COMMAND_NAME,
        app_name: APP_NAME,
        ...values
      }}
    />
  );
};
